import { gatewayClient, createService } from './connectors/httpClient';
import { ResponseModel } from './connectors/ResponseModel';

export type RenditionConfiguration = {
    id: number;
    name: string;
    displayName: string;
    description: string;
    type: 'IMAGE' | 'VIDEO' | 'PDF';
    tool: 'FFMPEG' | 'NUKE';
    parameters: string;
    extension: string;
    dynamic: boolean;
    disabled: null;
    containerType: null;
    downloadable: boolean;
    displayOrder: null | number;
    targets: string[];
};

const httpClient = gatewayClient('/');

const renditionsService = createService(httpClient, (client) => ({
    getRenditionConfigurations(
        customerId: number,
        creativeType: 'IMAGE' | 'VIDEO',
    ): Promise<ResponseModel<RenditionConfiguration[]>> {
        return client.get(`customer/${customerId}/rendition-configurations?creativeType=${creativeType}`);
    },
}));

export default renditionsService;
